import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/event';
const dashboardWorkflowAnalyticsUrl = `${path}/dashboardWorkflowAnalytics` ;
const dashboardRevenueDetailsUrl = `${path}/dashboardRevenueDetails` ;
const dashboardRequirementDetailsUrl = `${path}/dashboardRequirementDetails` ;
const dashboardBrochureDetailsUrl = `${path}/dashboardBrochureDetails` ;
const dashboardAbstractDetailsUrl = `${path}/dashboardAbstractDetails` ;
const dashboardRevenueCountriesDetailsUrl = `${path}/dashboardRevenueCountriesDetails` ;
const dashboardRevenueLeadByCurrencyDetailsUrl = `${path}/dashboardRevenueLeadByCurrencyDetails` ;
const dashboardRevenueLeadByPaymentTypeDetailsUrl = `${path}/dashboardRevenueLeadByPaymentTypeDetails` ;
const dashboardOccupancyStatusDetailsUrl = `${path}/dashboardOccupancyStatusDetails` ;
const dashboardAccommodationStatusDetailsUrl = `${path}/dashboardAccommodationStatusDetails` ;
const dashboardEventTypeStatusDetailsUrl = `${path}/dashboardEventTypeStatusDetails` ;
const conferenceEventUrl = base_url+'api/admin/conferenceEvent';
const webinarEventUrl = base_url+'api/admin/webinarEvent';

export const getData = async (params) => {
  const response = await api.post(dashboardWorkflowAnalyticsUrl, params);
  return response.data.data;
};

export const getRevenueData = async (params) => {
  const response = await api.post(dashboardRevenueDetailsUrl, params);
  return response.data;
}


export const getRequirementData = async (params) => {
  const response = await api.post(dashboardRequirementDetailsUrl, params);
  return response.data;
}



export const getBrochureData = async (params) => {
  const response = await api.post(dashboardBrochureDetailsUrl, params);
  return response.data;
}

export const getAbstractData = async (params) => {
  const response = await api.post(dashboardAbstractDetailsUrl, params);
  return response.data;
}

export const getRevenueCountriesData = async (params) => {
  const response = await api.post(dashboardRevenueCountriesDetailsUrl, params);
  return response.data;
}




export const getRevenueLeadByCurrencyData = async (params) => {
  const response = await api.post(dashboardRevenueLeadByCurrencyDetailsUrl, params);
  return response.data.data;
}

export const getRevenueLeadByPaymentTypeData = async (params) => {  
  const response = await api.post(dashboardRevenueLeadByPaymentTypeDetailsUrl, params);
  return response.data.data;
}

export const getOccupancyStatusData  = async (params) => {
  const response = await api.post(dashboardOccupancyStatusDetailsUrl, params);
  return response.data.data;
}

export const getAccommodationStatusData = async (params) => { 
  const response = await api.post(dashboardAccommodationStatusDetailsUrl, params);
  return response.data.data;
}

export const getEventTypeStatusData = async (params) => { 
  const response = await api.post(dashboardEventTypeStatusDetailsUrl, params);
  return response.data.data;
}

export const getconferenceEvent = async (params) => {
  const whereParam = params;
  const response = await api.post(conferenceEventUrl, whereParam);
  return response.data.data;
};

export const getwebinarEvent = async (params) => {
  const whereParam = params;
  const response = await api.post(webinarEventUrl, whereParam);
  return response.data.data;
};

